import { getParameterByName } from '@fable/utils'
import { StatsPlatform } from '../types'

export const platformParam = getParameterByName('platform')
export const isAndroidParam = !!platformParam && platformParam === 'android'

export const isPlatformAndroid = (platform: StatsPlatform | undefined) => {
  return isAndroidParam || (!!platform && platform === 'android')
}

export const inspectParam = getParameterByName('inspect')
export const isStatsInspect = !!inspectParam && inspectParam === 'true'

export const selfParam = getParameterByName('self')
export const isStatsSelfView = !!selfParam && selfParam === 'true'

export const onboardingParam = getParameterByName('onboarding')
export const isOnboardingView = !!onboardingParam && onboardingParam === 'true'

// MULTI-YEAR STATS
export const v2Param = getParameterByName('v2')
export const isStatsV2 = !!v2Param && v2Param === 'true'

export const summaryV2Param = getParameterByName('summaryV2')
export const isSummaryV2 = !!summaryV2Param && summaryV2Param === 'true'

// CUSTOM GOALS
export const customGoalsParam = getParameterByName('custom_goals')
export const hasCustomGoals = !!customGoalsParam && customGoalsParam === 'true'
export const periodTypeParam = getParameterByName('period_type')

// WEBVIEW FF
export const ffABTestParam = getParameterByName('ff_ab_test')
export const hasAbTestParam = !!ffABTestParam && ffABTestParam === 'true'
